module.exports = __webpack_public_path__ + "img/t3-salmon.1272e64c.png";